import * as React from "react";
import {
  Theme,
  makeStyles,
  createStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import { useApiClient } from "lib/store";
import { AnvokError } from "lib";
import { useErrorHandler } from "ErrorHandler";
import useRouter from "use-react-router";
import LoaderInline from "../components/LoaderInline";
import SnackbarStatic from "../components/SnackbarStatic";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "95%",
      maxWidth: "300",
    },
  })
);

type onCloseCallback = () => void;

interface Props {
  ids: string[];
  onClose: onCloseCallback;
}

const CreatePicking: React.FunctionComponent<Props> = React.memo(
  ({ ids, onClose }) => {
    const api = useApiClient();
    const [loading, setLoading] = React.useState("Traitement des commandes...");
    const [error, setError] = React.useState("");
    const [warn, setWarn] = React.useState("");
    const [redirectUrl, setRedirectUrl] = React.useState<string | undefined>(
      undefined
    );
    const { history } = useRouter();
    const errorHandler = useErrorHandler();
    const classes = useStyles();

    React.useEffect(() => {
      api
        .POST("/api/pickings", { body: { ids } })
        .then((r) => {
          if (r.error) {
            throw new AnvokError(r.error.message);
          }
          let redirect = true;
          if (r.data.errors.length > 0) {
            setError(`${r.data.errors.length} commandes non trouvées`);
            redirect = false;
          }
          if (r.data.warns.length > 0) {
            setWarn(
              `${r.data.warns.length} commandes ignorées car déja préparées`
            );
            redirect = false;
          }
          if (redirect) {
            history.push("/picking/" + r.data._id);
          } else {
            setRedirectUrl("/picking/" + r.data._id);
          }
        })
        .catch((err) => {
          errorHandler(
            new AnvokError(
              "Une erreur s'est produite pendant la création",
              "err",
              err
            )
          );
          onClose();
        })
        .finally(() => {
          setLoading("");
        });
    }, [ids, api, errorHandler, onClose, history]);

    const handleContinue = React.useCallback(() => {
      if (redirectUrl) {
        history.push(redirectUrl);
      }
    }, [history, redirectUrl]);

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog
        open={true}
        onClose={handleClose}
        aria-labelledby="types-form-dialog-title"
        classes={{ paper: classes.root }}
      >
        <DialogTitle id="types-form-dialog-title">
          Préparation de la liste de picking
        </DialogTitle>
        <DialogContent>
          <LoaderInline show={Boolean(loading)} message={loading} />
          {Boolean(error) && (
            <SnackbarStatic variant="error">{error}</SnackbarStatic>
          )}
          {Boolean(warn) && (
            <SnackbarStatic variant="warning">{warn}</SnackbarStatic>
          )}
        </DialogContent>
        <DialogActions>
          {!Boolean(loading) && (
            <Button color="primary" onClick={handleContinue}>
              Continuer
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
);

export default CreatePicking;
